var HISTORY_CODES = /* @__PURE__ */ ((HISTORY_CODES2) => {
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER"] = 101] = "C1_ORDER";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER"] = 102] = "C2_ORDER";
  HISTORY_CODES2[HISTORY_CODES2["TRANSFER"] = 103] = "TRANSFER";
  HISTORY_CODES2[HISTORY_CODES2["COLLATERAL"] = 104] = "COLLATERAL";
  HISTORY_CODES2[HISTORY_CODES2["BATCH"] = 105] = "BATCH";
  HISTORY_CODES2[HISTORY_CODES2["TAKE_ORDER"] = 106] = "TAKE_ORDER";
  HISTORY_CODES2[HISTORY_CODES2["L1_TX"] = 107] = "L1_TX";
  HISTORY_CODES2[HISTORY_CODES2["ERROR"] = 200] = "ERROR";
  HISTORY_CODES2[HISTORY_CODES2["BAD_REQUEST"] = 201] = "BAD_REQUEST";
  HISTORY_CODES2[HISTORY_CODES2["FORBIDDEN"] = 202] = "FORBIDDEN";
  HISTORY_CODES2[HISTORY_CODES2["NOT_FOUND"] = 203] = "NOT_FOUND";
  HISTORY_CODES2[HISTORY_CODES2["CONFLICT"] = 204] = "CONFLICT";
  HISTORY_CODES2[HISTORY_CODES2["CONTRACT_ERROR"] = 210] = "CONTRACT_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["NOT_IMPLEMENTED"] = 211] = "NOT_IMPLEMENTED";
  HISTORY_CODES2[HISTORY_CODES2["TIMEOUT"] = 212] = "TIMEOUT";
  HISTORY_CODES2[HISTORY_CODES2["BATCH_ERROR"] = 213] = "BATCH_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["SUCCESS"] = 500] = "SUCCESS";
  HISTORY_CODES2[HISTORY_CODES2["BATCH_SUCCESS"] = 501] = "BATCH_SUCCESS";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_NOT_CREATED"] = 301] = "C1_ORDER_NOT_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_CREATED"] = 601] = "C1_ORDER_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_NOT_CLOSED"] = 302] = "C1_ORDER_NOT_CLOSED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_DEACTIVATED"] = 605] = "C1_ORDER_DEACTIVATED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_CLOSED"] = 606] = "C1_ORDER_CLOSED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_NOT_ACTIVE"] = 303] = "C1_ORDER_NOT_ACTIVE";
  HISTORY_CODES2[HISTORY_CODES2["C1_BAD_L1_TX"] = 321] = "C1_BAD_L1_TX";
  HISTORY_CODES2[HISTORY_CODES2["C1_L1_TX_HANDLING_ERROR"] = 322] = "C1_L1_TX_HANDLING_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["C1_L1_EVENT_ERROR"] = 313] = "C1_L1_EVENT_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_USED"] = 612] = "C1_ORDER_USED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_UPDATED"] = 613] = "C1_ORDER_UPDATED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_COMPLETED"] = 614] = "C1_ORDER_COMPLETED";
  HISTORY_CODES2[HISTORY_CODES2["C1_ORDER_EXPIRED"] = 608] = "C1_ORDER_EXPIRED";
  HISTORY_CODES2[HISTORY_CODES2["C1_L1_TX_HANDLED"] = 620] = "C1_L1_TX_HANDLED";
  HISTORY_CODES2[HISTORY_CODES2["C1_L1_TRANSFER_TX_HANDLED"] = 621] = "C1_L1_TRANSFER_TX_HANDLED";
  HISTORY_CODES2[HISTORY_CODES2["C1_L1_TAKE_TX_HANDLED"] = 622] = "C1_L1_TAKE_TX_HANDLED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_NOT_CREATED"] = 401] = "C2_ORDER_NOT_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_CREATED"] = 701] = "C2_ORDER_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_NOT_CLOSED"] = 403] = "C2_ORDER_NOT_CLOSED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_CLOSED"] = 706] = "C2_ORDER_CLOSED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_DISABLED"] = 707] = "C2_ORDER_DISABLED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_NOT_ACTIVE"] = 402] = "C2_ORDER_NOT_ACTIVE";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_USED"] = 703] = "C2_ORDER_USED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_UPDATED"] = 704] = "C2_ORDER_UPDATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_ORDER_EXPIRED"] = 705] = "C2_ORDER_EXPIRED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_NOT_CREATED"] = 411] = "C2_REQUEST_NOT_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_FITTING_ORDER_NOT_FOUND"] = 413] = "C2_FITTING_ORDER_NOT_FOUND";
  HISTORY_CODES2[HISTORY_CODES2["C2_BTC_NONCE_NOT_AVAILABLE"] = 414] = "C2_BTC_NONCE_NOT_AVAILABLE";
  HISTORY_CODES2[HISTORY_CODES2["C2_L1_EVENT_ERROR"] = 415] = "C2_L1_EVENT_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_CREATED"] = 711] = "C2_REQUEST_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_UPDATED"] = 712] = "C2_REQUEST_UPDATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_FALLBACK_CALL"] = 713] = "C2_REQUEST_FALLBACK_CALL";
  HISTORY_CODES2[HISTORY_CODES2["C2_REFUND_REQUEST_CREATED"] = 716] = "C2_REFUND_REQUEST_CREATED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REFUND_REQUEST_EXECUTED"] = 717] = "C2_REFUND_REQUEST_EXECUTED";
  HISTORY_CODES2[HISTORY_CODES2["C2_FALLBACK_REFUND_CWEB"] = 718] = "C2_FALLBACK_REFUND_CWEB";
  HISTORY_CODES2[HISTORY_CODES2["C2_L1_TX_HANDLING_ERROR"] = 420] = "C2_L1_TX_HANDLING_ERROR";
  HISTORY_CODES2[HISTORY_CODES2["C2_BAD_L1_TX"] = 424] = "C2_BAD_L1_TX";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_NOT_ACTIVE"] = 412] = "C2_REQUEST_NOT_ACTIVE";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_EXPIRED"] = 416] = "C2_REQUEST_EXPIRED";
  HISTORY_CODES2[HISTORY_CODES2["C2_L1_TX_HANDLED"] = 720] = "C2_L1_TX_HANDLED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_EXECUTED"] = 714] = "C2_REQUEST_EXECUTED";
  HISTORY_CODES2[HISTORY_CODES2["C2_REQUEST_FEE_PAID"] = 715] = "C2_REQUEST_FEE_PAID";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_DEPOSIT_FAILED"] = 431] = "C2_COLLATERAL_DEPOSIT_FAILED";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_WITHDRAW_FAILED"] = 432] = "C2_COLLATERAL_WITHDRAW_FAILED";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_DEPOSIT"] = 731] = "C2_COLLATERAL_DEPOSIT";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_WITHDRAW"] = 732] = "C2_COLLATERAL_WITHDRAW";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_LOCKED"] = 733] = "C2_COLLATERAL_LOCKED";
  HISTORY_CODES2[HISTORY_CODES2["C2_COLLATERAL_UNLOCKED"] = 734] = "C2_COLLATERAL_UNLOCKED";
  return HISTORY_CODES2;
})(HISTORY_CODES || {});
export {
  HISTORY_CODES
};
//# sourceMappingURL=codes.js.map